<template>
  <v-card flat rounded="lg" outlined>
    <!-- <v-card-title class="subtitle-1 font-weight-bold pb-1" v-if="editar_carga"
      >Distribuir carga</v-card-title
    > -->
    <v-card-text class="h-100">
      <v-row dense>
        <v-col xl="3" lg="3" md="3" cols="12">
          <v-list-item dense>
            <v-list-item-content>
              <v-list-item-subtitle>Veículo</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold">{{
                veiculo.dados.descricao
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-divider vertical v-if="!isMobile() && !ver_detalhes "></v-divider>
        <v-col xl="3" lg="3" md="3" cols="12">
          <v-list-item dense>
            <v-list-item-content>
              <v-list-item-subtitle>Transportador</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold">{{
                veiculo.dados.nome_transportador
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-divider vertical v-if="!isMobile() && !ver_detalhes"></v-divider>
        <v-col xl="3" lg="3" md="3" cols="12">
          <v-list-item dense>
            <v-list-item-content>
              <v-list-item-subtitle>Motorista</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold">{{
                veiculo.dados.nome_motorista
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-divider vertical v-if="!isMobile() && !ver_detalhes"></v-divider>
        <v-col xl="3" lg="3" md="3" cols="12">
          <v-list-item dense>
            <v-list-item-content>
              <v-list-item-subtitle>Total Carregado</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold"
                ><v-chip small>{{ totalCarregado() }} Kgs</v-chip>
                <p v-if="cargaSelec.placa == '' || veiculo.dados.capac_max < 99999" class="mb-0 mt-1">
                  Capac. máx: {{ veiculo.dados.capac_max }} Kgs
                </p></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>

      <v-divider class="mt-1"></v-divider>

      <v-card class="mt-5 " rounded="lg" outlined v-if="cargaSelec.inf_pedido">
        <v-card-title class="subtitle-2 font-weight-bold"
          >Pedidos adicionados</v-card-title
        >
        <v-card-text>
          <v-row dense>
            <v-col
              cols="12"
              align-self="center"
              class="text-center"
              v-if="cargaSelec.pode_editar && cargaSelec.pode_add_pedido && !ver_detalhes"
            >
              <btn-adicionar-pedido-carga />
            </v-col>
            <v-col
              xl="4"
              lg="6"
              md="6"
              cols="12"
              v-for="(ped, i) in cargaSelec.dist_caixas.filter(
                (dc) => dc.caixa == 0
              )"
              :key="i"
            >
              <panel-pedido-carga :pedido="ped" :pos="i" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row class="pl-8 mb-3" :class="{'mt-5' : isMobile()}" v-if="veiculo.dados.placa != ''" :style="!isMobile() ? 'margin-top: 60px' : ''">
        <caminhao-imagem :width="ver_detalhes ? 1200 : 1400">          
          <v-row class="posicao-caixa">            
            <caixa-veiculo-form-carga
              v-for="(cx, i) in filtrarCaixas()"
              :key="i"
              :caixa="cx"
              class="mr-1"
            />
          </v-row>
        </caminhao-imagem>
      </v-row>

      <v-row
        v-if="
          cargaSelec.dist_caixas.length > 0 &&
          cargaSelec.pode_editar &&
          !ver_detalhes
        "
        class="mt-3"
      >
        <v-col cols="12" :class="{ 'mt-3': isMobile() }">
          <btn-confirmar-form-carga />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BtnAdicionarPedidoCarga from "./BtnAdicionarPedidoCarga.vue";
import BtnConfirmarFormCarga from "./BtnConfirmarFormCarga.vue";
import CaixaVeiculoFormCarga from "./CaixaVeiculoFormCarga.vue";
import CaminhaoImagem from "./CaminhaoImagem.vue";
import PanelPedidoCarga from "./PanelPedidoCarga.vue";
export default {
  components: {
    CaminhaoImagem,
    CaixaVeiculoFormCarga,
    BtnConfirmarFormCarga,
    PanelPedidoCarga,
    BtnAdicionarPedidoCarga,
  },
  computed: mapState("formacaoCarga", [
    "veiculo",
    "cargaSelec",
    "id_carga",
    "ver_detalhes",
  ]),
  methods: {
    ...mapGetters("formacaoCarga", ["totalCarregado"]),
    isMobile() {
      return this.$mq == "sm";
    },
    filtrarCaixas() {
      if (this.isMobile())
        return this.veiculo.dados.caixas.filter(
          (cx) => cx.capacidade.length > 0
        );
      return this.veiculo.dados.caixas;
    },
  },
};
</script>

<style>
.posicao-caixa {
  position: absolute;
  left: 28%;
  top: 9%;
  height: 52% !important;
  width: 72%;
  animation: fadeInFromTop 0.8s ease-out;
}

@media only screen and (max-width: 750px) {
  .posicao-caixa {
    position: relative;
    left: 0%;
    top: 0%;
    width: 100%;
    height: 100%;
  }
}

@keyframes fadeInFromTop {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>